import zappy from "@zappy-ride/library.react.components";
import { OutputEmissions } from "./Emissions";

export * from "./Emissions";

zappy.FactoryInstance.registerComponent(OutputEmissions);